import { useCallback, useRef, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectDispatchPoint, selectShowInvalids, selectCountry } from '@store/order/selectors';
import { setDispatchPoint } from '@store/order/slice';
import { Button } from 'react-aria-components';
import { invalidFormValue } from '@components/utils';
import { DispatchPoint } from '@api/types/DispatchPoint';
import { convertPplToDispatchPoint } from '@pages/order/payment-shipping/ppl-script/convertors';
import { isPplParcelshopEvent } from '@pages/order/payment-shipping/ppl-script/typescriptguards';
import useScript from '@components/hooks/useScript/useScript';
import { CountryEnum } from '@api/types/CountryEnum';



export const PplScript = (): JSX.Element => {

	const dialogRef = useRef<HTMLDialogElement | null>(null);
	const dispatchPoint = useSelector(selectDispatchPoint);
	const showInvalids = useSelector(selectShowInvalids);
	const country = useSelector(selectCountry);

	const dispatch = useDispatch();
	const updateDispatchPoint = (value: DispatchPoint | null) => dispatch(setDispatchPoint(value));
	
	const [ isDialogOpen, setIsDialogOpen ] = useState(false);
	useScript('https://www.ppl.cz/sources/map/main.js');

	const handleSelectDispatchPoint = (event: Event) => {
		if (isPplParcelshopEvent(event)) {
			const convertedObject = convertPplToDispatchPoint(event.detail);
			if (!convertedObject) return;

			updateDispatchPoint(convertedObject);
			closeDialog();
		}
	};
	
	
	useEffect(() => {
		document.addEventListener('ppl-parcelshop-map', handleSelectDispatchPoint);
		return () => {
			document.removeEventListener('ppl-parcelshop-map', handleSelectDispatchPoint);
		}
	}, []);


	useEffect(() => {
		const link = document.createElement('link');
		link.href = 'https://www.ppl.cz/sources/map/main.css';
		link.rel = 'stylesheet';
		document.head.appendChild(link);

		return () => {
			document.head.removeChild(link);
		}
	}, []);

	
	useEffect(() => {
		if (isDialogOpen) {
			window.dispatchEvent(new Event('resize'));
		}
	}, [ isDialogOpen ]);
	

	const openDialog = useCallback(() => {
		if (dialogRef && dialogRef.current) {
			dialogRef.current.showModal();
			setIsDialogOpen(true);
		}
	},[ dialogRef ]);

	
	const closeDialog = useCallback(() => {
		if (dialogRef && dialogRef.current) {
			dialogRef.current.close();
			setIsDialogOpen(false);
		}
	},[ dialogRef ]);


	return (
		<>
			<label className='dispatch-point-label'>
				Zvolené výdejní místo: <span>*</span> {showInvalids && invalidFormValue(dispatchPoint) &&
					<p className='form-invalid'>Povinné pole</p>}
			</label>

			<div className='dispatch-point-text'>
				
				<p>{dispatchPoint ? `${dispatchPoint.name}, ${dispatchPoint.street}, ${dispatchPoint.city}` : 'Nevybráno'}</p>

				<Button className='app-form-button disable-selection' autoFocus={false} onPress={openDialog}>
					{dispatchPoint ? 'Změnit' : 'Vybrat'}
				</Button>

			</div>

			<dialog
				className='ppl-dispatch-modal'
				ref={dialogRef}
			 	open={isDialogOpen} 
			 	onClose={closeDialog}>
					<div id="ppl-parcelshop-map" data-datamode="default"  data-country={country === CountryEnum.sk ? 'sk' : 'cz'} data-countries="cz,sk"></div>
					<Button className='disable-selection modal-close-button' autoFocus={false} onPress={closeDialog}>
						Zavřít
					</Button>
			</dialog>
		</>
	);
};